import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import Diversity2Icon from '@mui/icons-material/Diversity2';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BadgeIcon from '@mui/icons-material/Badge';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import HouseIcon from '@mui/icons-material/House';
import LocalOfferIcon from '@mui/icons-material/LocalOffer'; // Item/Tag icon
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CategoryIcon from '@mui/icons-material/Category';
import LaptopIcon from '@mui/icons-material/Laptop';
import DriveEtaIcon from '@mui/icons-material/DriveEta';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import GrassIcon from '@mui/icons-material/Grass';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import ReportIcon from '@mui/icons-material/Report';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import DescriptionIcon from '@mui/icons-material/Description';
import SyncIcon from '@mui/icons-material/Sync';
import AddCardIcon from '@mui/icons-material/AddCard';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import BasketIcon from '@mui/icons-material/ShoppingBasket';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import PixIcon from '@mui/icons-material/Pix';
import CommuteIcon from '@mui/icons-material/Commute';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import { AuthProvider, useAuth } from "./AuthContext";
import PolicyIcon from '@mui/icons-material/Policy';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Person2Icon from '@mui/icons-material/Person2';

//Logout
import Logout from "./Logout";
//SessionTimeOut
import SessionTimeout from "./SessionTimeout";
//Home 
import Home from "./components/pages/Home";
// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";
//Category
import ProductCategoryCreate from "./components/pages/ProductCategory/Create";
import ProductCategoryEdit from "./components/pages/ProductCategory/Edit";
import ProductCategoryIndex from "./components/pages/ProductCategory/Index";
// Item
import ItemIndex from './components/pages/Item/Index';
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemDetail from "./components/pages/Item/Detail";
import ItemPriceChange from "./components/pages/Item/PriceChange";
//DriverRegistration
import { DriverRegistrationCreate } from "./components/pages/DriverRegistration/Create";
import DriverRegistrationIndex from "./components/pages/DriverRegistration/Index";
//vehicle registration
import { VehicleRegistrationCreate } from "./components/pages/VehicleRegistartion/Create";
import VehicleRegistrationIndex from "./components/pages/VehicleRegistartion/Index";
import VehicleEdit from "./components/pages/VehicleRegistartion/Edit";
//UserType
import UserTypeCreate from "./components/pages/UserType/Create";
//import ProductCategoryEdit from "./components/pages/ProductCategory/Edit";
import UserTypeIndex from "./components/pages/UserType/Index";
import UserTypeEdit from "./components/pages/UserType/Edit";
//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";
//Staff
import StaffIndex from "./components/pages/Staff/index";
import StaffCreate from "./components/pages/Staff/create";
import StaffEdit from "./components/pages/Staff/Edit";
//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//AccountHead
import AccountHeadCreate from "./components/pages/AccountHead/Create";
import AccountHeadIndex from "./components/pages/AccountHead/Index";
import AccountHeadEdit from "./components/pages/AccountHead/Edit";
//Office Expense
import OfficeExpenseCreate from "./components/pages/Expense/Create";
import OfficeExpenseIndex from "./components/pages/Expense/Index";
// import OfficeExpenseEdit from "./components/pages/Expense/Edit";
import ExpenseEditPage from "./components/pages/Expense/Edit";
import Index from "./components/pages/Expense/IndexForStaff";
//Route
import RouteIndex from "./components/pages/Route/Index";
import RouteCreate from "./components/pages/Route/Create";
import RouteEdit from "./components/pages/Route/Edit";
//BagMaster
import BagIndex from "./components/pages/BagMaster/Index";
import BagCreate from "./components/pages/BagMaster/Create";
import BagEdit from "./components/pages/BagMaster/Edit";
//customer
import CustomerIndex from "./components/pages/Customer/Index";
import { CustomerCreate } from './components/pages/Customer/Create';
import CustomerEdit from "./components/pages/Customer/Edit";
//Trip
import TripCreate from "./components/pages/Trip/Create";
import TriporderedIndexs from "./components/pages/SaleOrder/TripOrderedIndex";
import TripFinishIndex from "./components/pages/Trip/Index";
import RouteClosingSaleOrderEdit from "./components/pages/Trip/Edit";
import RouteSaleOrderCreate from "./components/pages/Trip/SaleOrderCreate";
//Sale 
import SaleDetails from "./components/pages/Sale/SaleDetails";
//SaleOrder
import SaleOrderIndex from "./components/pages/SaleOrder/Index";
import SaleOrderCreate from "./components/pages/SaleOrder/SaleOrderCreate";
import EstimatePrint from "./components/pages/SaleOrder/Estimate";
import AdditionalOrderCreate from "./components/pages/SaleOrder/Additionalorder";
import Extraloading from "./components/pages/SaleOrder/ExtraLoading";
import AddtionalOrderIndex from "./components/pages/AdditionalOrder/Index";
//import SaleOrderEdit from "./components/pages/SaleOrder/Edit";
import SaleOrderEdit from "./components/pages/SaleOrder/Saleorderedit";
import ExtraloadingIndex from "./components/pages/ExtraLoading/ExtraLoadingIndex";
import AdditionalOrderEdit from "./components/pages/AdditionalOrder/AdditionalOrderEdit";
import ExtraLoadingEdit from "./components/pages/ExtraLoading/ExtraLoadingEdit";
import ExtraLoadingSaleIndex from "./components/pages/ExtraLoading/ExtraLoadingSaleIndex";
import ExtraSaleOrderCreate from "./components/pages/ExtraLoading/create";
import ExtraSaleOrderEdit from "./components/pages/ExtraLoading/SaleEdit";
import SaleExtraOrderEdit from "./components/pages/ExtraLoading/SaleExtraOrderEdit";

//proforma
import PROIndex from "./components/pages/Proforma/Index";
import PROSaleOrderCreate from "./components/pages/Proforma/Create";
import BillPrint from "./components/pages/Proforma/Bill";
import PSaleOrderEdit from "./components/pages/Proforma/Pedit";
import PROBilledIndex from "./components/pages/Proforma/OrderedCustomerList";
import NongstTriporderedIndexs from "./components/pages/Proforma/NonGstTripIndex";
//SaleReturn 
import SaleReturnCreate from "./components/pages/SaleReturn/Create";
import SaleReturnIndex from "./components/pages/SaleReturn/Index";
import SaleOrderReturn from "./components/pages/SaleReturn/SaleOrderReturn";
import SaleReturnEdit from "./components/pages/SaleReturn/Edit";
import SaleReturnDetails from "./components/pages/Sale/SaleReturnDetails";
//SaleReturn Approval
import SaleReturnApprovalCreate from "./components/pages/SaleReturnApproval/Create";
import SaleReturnApprovalIndex from "./components/pages/SaleReturnApproval/Index";
import SaleReturnApprovalEdit from "./components/pages/SaleReturnApproval/Edit";
import ApprovalIndex from "./components/pages/SaleReturnApproval/ApprovalIndex";
//Sale Invoice
import SaleInvoice from "./components/pages/Invoice/SaleInvoice";
import DashboardSaleInvoice from "./components/pages/Invoice/Dashboardinvoice";
import InvoicePrint from "./components/pages/Invoice/Estimate";
import NongstBillPrint from "./components/pages/Invoice/Bill";
import TaxBillPrint from './components/pages/Invoice/TaxBil';
// Report
import DespatchReport from "./components/pages/Report/DespatchReport";
import GstReports from "./components/pages/Report/GstReport";
import SalesnewReport from "./components/pages/Report/SalesNewReport";
import CustomerOrderedItems from "./components/pages/Report/OrderSheetDetails";
import ClosingSummary from "./components/pages/Report/ClosingSummary";
import routewisecollection from "./components/pages/Report/CollectionRouteWise";
import CollectionPaymentReport from "./components/pages/Report/CollectionPaymentReport";
import ExpenseSummeryReport from "./components/pages/Report/ExpenseSummeryReport";
import RouteOrderlistReport from "./components/pages/Report/RouteOrdersList";
import Ledger from "./components/pages/Report/ledger";
import Salegstreport from "./components/pages/Report/SalesGST";
import RouteWiseOutstandingReport from "./components/pages/Report/OutstandingReport";
import ForLoadingDespatchReport from "./components/pages/Report/ForLoadingReport";
import MonthlySaleReport from "./components/pages/Report/MonthWiseSaleReport";
import ClosingSummaryNew from "./components/pages/Report/ClosingSummaryNew";
import SaleReturnReport from "./components/pages/Report/SaleReturnReport";
import ChequeStatus from "./components/pages/Report/ChequeStatus";
import DeletedReceiptList from "./components/pages/Report/PaymentReceiptDeleted";
//import CounterSaleReport from "./components/pages/Report/CounterSaleReport";
// bank
import { BankCreate } from "./components/pages/Bank/Create";
import BankIndex from "./components/pages/Bank/Index";
import BankEdit from "./components/pages/Bank/Edit";
//Delivery
import Delivery from "./components/pages/Delivery/Delivery";
//Deliveryreceipt 
import ReceiptIndex from "./components/pages/Despatch/Index";
import Despatch from "./components/pages/Despatch/Despatch";
import ReceiptCreate from "./components/pages/Despatch/Create";
import ReceiptDetails from "./components/pages/Despatch/Details";
//PriceList
import PriceList from "./components/pages/Item/PriceList";
//Income
import IncomeIndex from "./components/pages/Income/Index";
import IncomeCreate from "./components/pages/Income/Create";
import IncomeEdit from "./components/pages/Income/Edit";
//Counter Sale

import CounterSaleCreate from "./components/pages/CounterSale/Create";
//import CounterSaleEdit from "./components/pages/CounterSale/Edit";
import CounterSaleIndex from "./components/pages/CounterSale/Index";
//Route Template
import RouteTemplate from "./components/pages/RouteTemplate/Index";




const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [serviceOpen, setserviceOpen] = useState(false);
  const [AccountOpen, setAccountOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleserviceClick = () => {
    setserviceOpen(!serviceOpen);
  };

  const handleaccountClick = () => {
    setAccountOpen(!AccountOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };


  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, username } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />

        <AppBar position="static" style={{ backgroundColor: '#36454F', height: '50px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px', position: 'relative' }}>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h6"
              component="div"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }}
            >
              {/* Left Section */}
              <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <Link
                  to="/Home"
                  style={{
                    textDecoration: 'none',
                    color: 'whitesmoke',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography
                    variant="h6"
                    //className="dual-text"
                    component="div"
                    style={{ marginLeft: '10px', fontWeight: 'bolder', position: 'relative' }}
                  >
                    {/* <span style={{ color: 'whitesmoke' }}>{companyName.slice(0, 1)}</span>
                  <span style={{ color: 'whitesmoke' }}>{companyName.slice(1, 2)}</span>
                  <span style={{ color: '#F4CE14' }}>{companyName.slice(2)}</span> */}
                    {companyName}
                  </Typography>
                </Link>
              </div>

              {/* Right Section */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Typography
                  component="div"
                  style={{
                    fontWeight: 'bolder',
                    color: 'whitesmoke',
                    fontFamily: 'monospace',
                    fontSize: '14px'
                  }}
                >
                  <Person2Icon /> {username}
                </Typography>
                <div className="white-icon" style={{ marginTop: '5px' }}>
                  <Logout />
                </div>
              </div>
            </Typography>

          </Toolbar>
        </AppBar>

        <Drawer anchor="left"
          open={drawerOpen}
          onClose={handleDrawerClose} >



          <List>
            <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
              <HouseIcon /> <ListItemText primary="HOME" />
            </ListItem>

            <ListItem button onClick={handleMasterClick}>
              <ListItemText primary="MASTER" />
              {masterOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/RouteIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AltRouteIcon style={{ color: 'darksalmon' }} />  <ListItemText primary="Route" />
                </ListItem>
                <ListItem button component={NavLink} to="/RouteTemplate" activeClassName="selected" onClick={handleDrawerClose}>
                  <AltRouteIcon style={{ color: 'teal' }} />  <ListItemText primary="Route Template" />
                </ListItem>
                <ListItem button component={NavLink} to="/BagIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <LocalMallIcon style={{ color: 'coral' }} />  <ListItemText primary="Bag Master" />
                </ListItem>
                <ListItem button component={NavLink} to="/ProductCategoryIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <CategoryIcon style={{ color: 'darkslateblue' }} /><ListItemText primary="Category" style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <LocalOfferIcon style={{ color: 'teal' }} /> <ListItemText primary="Item" />
                </ListItem>
                <ListItem button component={NavLink} to="/ItemPriceChange" activeClassName="selected" onClick={handleDrawerClose}>
                  <PriceChangeIcon style={{ color: 'Violet' }} /> <ListItemText primary="Item Price Change" />
                </ListItem>
                <ListItem button component={NavLink} to="/PriceList" activeClassName="selected" onClick={handleDrawerClose}>
                  <PriceChangeIcon style={{ color: 'darkmagenta' }} /> <ListItemText primary="Price List" />
                </ListItem>
                <ListItem button component={NavLink} to="/AccountHeadIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountBalanceIcon style={{ color: 'darkkhaki' }} /><ListItemText primary="Account Head" style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/BankIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AddCardIcon style={{ color: '#00AD83' }} /><ListItemText primary="Bank" style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/CustomerIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'blueviolet', fontWeight: 'bolder' }} />  <ListItemText primary="Customer" style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/UserTypeIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <LaptopIcon style={{ color: 'teal' }} />  <ListItemText primary="User Type" />
                </ListItem>

                <ListItem button component={NavLink} to="/VehicleRegistrationIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <LocalShippingIcon style={{ color: 'darkgoldenrod' }} />  <ListItemText primary="Vehicle Registration" />
                </ListItem>


              </List>
            </Collapse>

            <ListItem button onClick={handleserviceClick}>
              <ListItemText primary="TRANSACTION" />
              {serviceOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={serviceOpen} timeout="auto" unmountOnExit>

              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/CounterSaleCreate" activeClassName="selected" onClick={handleDrawerClose}>
                  <ShoppingCartCheckoutIcon style={{ color: 'darksalmon' }} />  <ListItemText primary="Counter Sale" />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleOrderIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ShoppingCartCheckoutIcon style={{ color: 'darkorange' }} />  <ListItemText primary="Sale Order" />
                </ListItem>

                <ListItem button component={NavLink} to="/ExtraLoadingSaleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ShoppingCartCheckoutIcon style={{ marginLeft: '3px' }} /><ListItemText primary="ExtraLoading Sale" />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleInvoice" activeClassName="selected" onClick={handleDrawerClose}>
                  <DescriptionIcon style={{ color: 'darkorchid' }} />  <ListItemText primary="Sale Invoice" />
                </ListItem>
                <ListItem button component={NavLink} to="/TripFinishIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <EmojiTransportationIcon style={{ color: '#00A36C' }} />  <ListItemText primary="Edit-RouteClose" />
                </ListItem>
                <ListItem button component={NavLink} to="/Delivery" activeClassName="selected" onClick={handleDrawerClose}>
                  <Diversity2Icon style={{ color: 'darkblue' }} />  <ListItemText primary="Delivery" />
                </ListItem>
                <ListItem button component={NavLink} to="/SaleReturnIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <SyncIcon style={{ color: '#C80815' }} />  <ListItemText primary="Sale Return" />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleReturnApprovalIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PublishedWithChangesIcon style={{ color: '#008000' }} />  <ListItemText primary="Sale Return & Approval" />
                </ListItem>


              </List>
            </Collapse>

            <ListItem button onClick={handleaccountClick}>
              <ListItemText primary="ACCOUNTS" />
              {AccountOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={AccountOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/OfficeExpenseCreate" activeClassName="selected" onClick={handleDrawerClose}>
                  <AttachMoneyIcon style={{ color: 'darkgoldenrod' }} /> <ListItemText primary="Office Expense" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ReceiptIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <ReceiptLongIcon
                    style={{
                      color: '#800000',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}
                  />  <ListItemText primary="Receipt" />
                </ListItem>
                <ListItem button component={NavLink} to="/CollectionPaymentReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <CurrencyRupeeIcon style={{ color: '#BF40BF', fontWeight: 'bold' }} /> <ListItemText primary="Collection Payment " style={{ marginLeft: '3px' }} />
                </ListItem>

              </List>
            </Collapse>
            <ListItem button onClick={handleReportClick}>
              <ListItemText primary="REPORT" />
              {reportOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>

              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/ForLoadingDespatchReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <CommuteIcon style={{ color: '#021727' }} /> <ListItemText primary="Despatch (For Loading) " style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/DespatchReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <CommuteIcon style={{ color: '#021727' }} /> <ListItemText primary="Despatch " style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/RouteOrderlistReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <ReportIcon style={{ color: 'darkgoldenrod' }} /> <ListItemText primary="Sort Order List " style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/CustomerOrderedItems" activeClassName="selected" onClick={handleDrawerClose}>
                  <BasketIcon style={{ color: 'darksalmon' }} />  <ListItemText primary="Order Sheet (Orderd Item Details)" />
                </ListItem>
                <ListItem button component={NavLink} to="/ClosingSummary" activeClassName="selected" onClick={handleDrawerClose}>
                  <TransferWithinAStationIcon style={{ color: 'teal' }} /> <ListItemText primary="Closing Summary " style={{ marginLeft: '3px' }} />
                </ListItem>


                <ListItem button component={NavLink} to="/ExpenseSummeryReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <LocalGasStationIcon style={{ color: '#FF004F', fontWeight: 'bold' }} />
                  <ListItemText primary="Expense Summary" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/GstReports" activeClassName="selected" onClick={handleDrawerClose}>
                  <PixIcon style={{ color: 'brown' }} /> <ListItemText primary="GST" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SalesnewReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'teal' }} /> <ListItemText primary="DSR " style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/MonthlySaleReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'red' }} /> <ListItemText primary="Sales" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/routewisecollection" activeClassName="selected" onClick={handleDrawerClose}>
                  <ReportIcon style={{ color: 'darkgoldenrod' }} /> <ListItemText primary="Collection Summary " style={{ marginLeft: '3px' }} />
                </ListItem>



                <ListItem button component={NavLink} to="/Ledger" activeClassName="selected" onClick={handleDrawerClose}>
                  <PersonIcon style={{ color: 'darkolivegreen' }} /> <ListItemText primary="Customer Ledger  " style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/DeletedReceiptList" activeClassName="selected" onClick={handleDrawerClose}>
                  <PixIcon style={{ color: 'brown' }} /> <ListItemText primary=" Activity Report " style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/RouteWiseOutstandingReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <PeopleIcon style={{ color: 'Black' }} /> <ListItemText primary="OutStanding  " style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/SaleReturnReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: 'Blue' }} /> <ListItemText primary="Sales Return" style={{ marginLeft: '3px' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/ChequeStatus" activeClassName="selected" onClick={handleDrawerClose}>
                  <CreditScoreIcon style={{ color: 'Green' }} /> <ListItemText primary="Cheque Status" style={{ marginLeft: '3px' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Salegstreport" activeClassName="selected" onClick={handleDrawerClose}>
                  <FileDownloadIcon style={{ color: 'blueviolet' }} /> <ListItemText primary="Tally Export" style={{ marginLeft: '3px' }} />
                </ListItem>
                {/* <ListItem button component={NavLink} to="/CounterSaleReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <BasketIcon style={{ color: 'darksalmon' }} />  <ListItemText primary="Counter Sale" />
                </ListItem> */}
              </List>

            </Collapse>

            <ListItem button onClick={handleUserClick}>
              <ListItemText primary="USER" />
              {userOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/StaffIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <PeopleIcon style={{ color: 'blueviolet', fontWeight: 'bolder' }} /> <ListItemText primary="Staff" style={{ marginLeft: '3px' }} />
                </ListItem>


                <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <AccountCircleIcon style={{ color: 'teal' }} />  <ListItemText primary="User" />
                </ListItem>

                <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                  <BadgeIcon style={{ color: 'darkorange' }} />  <ListItemText primary="Role" />
                </ListItem>

                <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
                  <SettingsIcon style={{ color: 'darkolivegreen' }} /> <ListItemText primary="Change Password" />
                </ListItem>

              </List>
            </Collapse>



          </List>
        </Drawer>



        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Home" exact component={Home} />

          {/* Company */}
          <Route path="/CompanyIndex" component={CompanyIndex} />
          <Route path="/CompanyCreate" component={CompanyCreate} />
          <Route path="/CompanyEdit/:id" component={CompanyEdit} />

          {/* Customer */}
          <Route path="/CustomerIndex" component={CustomerIndex} />
          <Route path="/CustomerCreate" component={CustomerCreate} />
          <Route path="/CustomerEdit/:id" component={CustomerEdit} />


          {/* ProductCategory */}
          <Route path="/ProductCategoryIndex" component={ProductCategoryIndex} />
          <Route path="/ProductCategoryCreate" component={ProductCategoryCreate} />
          <Route path="/ProductCategoryEdit/:id" component={ProductCategoryEdit} />

          {/* DriverRegistration */}
          <Route path="/DriverRegistrationCreate" component={DriverRegistrationCreate} />
          <Route path="/DriverRegistrationIndex" component={DriverRegistrationIndex} />

          {/* VehicleRegistration */}
          <Route path="/VehicleRegistrationCreate" component={VehicleRegistrationCreate} />
          <Route path="/VehicleRegistrationIndex" component={VehicleRegistrationIndex} />
          <Route path="/VehicleEdit/:id" component={VehicleEdit} />

          {/* Item */}
          <Route path="/ItemIndex" component={ItemIndex} />
          <Route path="/ItemCreate" component={ItemCreate} />
          <Route path="/ItemEdit/:id" component={ItemEdit} />
          <Route path="/ItemDetail/:id" component={ItemDetail} />
          <Route path="/ItemPriceChange" component={ItemPriceChange} />

          {/* Trip */}
          <Route path="/TripCreate" component={TripCreate} />
          <Route path="/TriporderedIndexs/:id" component={TriporderedIndexs} />
          <Route path="/NongstTriporderedIndexs/:id" component={NongstTriporderedIndexs} />
          <Route path="/TripFinishIndex" component={TripFinishIndex} />
          <Route path="/RouteClosingSaleOrderEdit/:id" component={RouteClosingSaleOrderEdit} />
          <Route path="/RouteSaleOrderCreate/:id/:tid" component={RouteSaleOrderCreate} />

          {/* SaleOrder */}
          <Route path="/SaleOrderIndex" component={SaleOrderIndex} />
          <Route path="/SaleOrderCreate/:id/:tid" component={SaleOrderCreate} />
          <Route path="/SaleOrderEdit/:id" component={SaleOrderEdit} />
          <Route path="/estimatePrint/:id" component={EstimatePrint} />
          <Route path="/Extraloading/:id" component={Extraloading} />
          <Route path="/AdditionalOrderCreate/:id" component={AdditionalOrderCreate} />
          {/* Add SaleOrder */}
          <Route path="/AddtionalOrderIndex/:id" component={AddtionalOrderIndex} />
          <Route path="/AdditionalOrderEdit/:id" component={AdditionalOrderEdit} />
          {/* extra SaleOrder */}
          <Route path="/ExtraloadingIndex/:id" component={ExtraloadingIndex} />
          <Route path="/ExtraloadingEdit/:id" component={ExtraLoadingEdit} />
          <Route path="/ExtraLoadingSaleIndex" component={ExtraLoadingSaleIndex} />
          {/* <Route path="/ExtraSaleOrderCreate/:id" component={ExtraSaleOrderCreate} />*/}
          <Route path="/ExtraSaleOrderCreate/:id/:tid" component={ExtraSaleOrderCreate} />
          <Route path="/ExtraSaleOrderEdit/:id" component={ExtraSaleOrderEdit} />
          <Route path="/SaleExtraOrderEdit/:id" component={SaleExtraOrderEdit} />
          {/* PRO.SaleOrder */}
          <Route path="/PROIndex" component={PROIndex} />
          <Route path="/PROBilledIndex" component={PROBilledIndex} />
          <Route path="/PROSaleOrderCreate/:id/:tid" component={PROSaleOrderCreate} />
          <Route path="/BillPrint/:id" component={BillPrint} />
          <Route path="/PSaleOrderEdit/:id" component={PSaleOrderEdit} />

          {/* SaleReturn */}
          <Route path="/SaleReturnCreate" component={SaleReturnCreate} />
          <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
          <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
          <Route path="/SaleOrderReturn/:id" component={SaleOrderReturn} />

          {/* SaleReturnApproval */}
          <Route path="/SaleReturnApprovalCreate" component={SaleReturnApprovalCreate} />
          <Route path="/SaleReturnApprovalIndex" component={SaleReturnApprovalIndex} />
          <Route path="/SaleReturnApprovalEdit/:id" component={SaleReturnApprovalEdit} />
          <Route path="/ApprovalIndex/:id" component={ApprovalIndex} />
          {/* BagMaster */}

          {/* AccountHead*/}
          <Route path="/AccountHeadIndex" component={AccountHeadIndex} />
          <Route path="/AccountHeadCreate" component={AccountHeadCreate} />
          <Route path="/AccountHeadEdit/:id" component={AccountHeadEdit} />

          {/* Expense By Office */}
          <Route path="/OfficeExpenseIndex" component={OfficeExpenseIndex} />
          <Route path="/OfficeExpenseCreate" component={OfficeExpenseCreate} />
          {/* <Route path="/OfficeExpenseEdit/:id" component={OfficeExpenseEdit} /> */}
          <Route path="/ExpenseEditPage/:id" component={ExpenseEditPage} />
          <Route path="/Index" component={Index} />

          {/* Route */}
          <Route path="/RouteIndex" component={RouteIndex} />
          <Route path="/RouteCreate" component={RouteCreate} />
          <Route path="/RouteEdit/:id" component={RouteEdit} />
          {/* Route Template */}
          <Route path="/RouteTemplate" component={RouteTemplate} />

          {/* BagMaster */}
          <Route path="/BagIndex" component={BagIndex} />
          <Route path="/BagCreate" component={BagCreate} />
          <Route path="/BagEdit/:id" component={BagEdit} />

          {/* UserType */}
          <Route path="/UserTypeIndex" component={UserTypeIndex} />
          <Route path="/UserTypeCreate" component={UserTypeCreate} />
          <Route path="/UserTypeEdit" component={UserTypeEdit} />
          {/* <Route path="/OfficeExpenseEdit/:id" component={OfficeExpenseEdit} /> */}

          {/* User */}
          <Route path="/UserIndex" component={UserIndex} />
          <Route path="/UserCreate" component={UserCreate} />
          <Route path="/UserEdit/:id" component={UserEdit} />
          <Route path="/UserDetail/:id" component={UserDetail} />
          <Route path="/PasswordChange" component={PasswordChange} />

          {/* Staff */}
          <Route path="/StaffIndex" component={StaffIndex} />
          <Route path="/StaffCreate" component={StaffCreate} />
          <Route path="/StaffEdit/:id" component={StaffEdit} />

          {/* Role */}
          <Route path="/RoleIndex" component={RoleIndex} />
          <Route path="/RoleDetail/:id" component={RoleDetail} />

          {/* Sale Invoice DashboardSaleInvoice*/}
          <Route path="/SaleInvoice" component={SaleInvoice} />
          <Route path="/DashboardSaleInvoice/:id" component={DashboardSaleInvoice} />
          <Route path="/InvoicePrint/:id" component={InvoicePrint} />
          <Route path="/NongstBillPrint/:id" component={NongstBillPrint} />
          <Route path="/TaxBillPrint/:id" component={TaxBillPrint} />
          {/* Sale Return and Sale Details Pages*/}
          <Route path="/SaleDetails/:id" component={SaleDetails} />
          <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />

          {/* Report */}
          <Route path="/DespatchReport" component={DespatchReport} />
          <Route path="/GstReports" component={GstReports} />
          <Route path="/ClosingSummaryNew" component={ClosingSummaryNew} />
          <Route path="/CustomerOrderedItems" component={CustomerOrderedItems} />
          <Route path="/ClosingSummary" component={ClosingSummary} />
          <Route path="/routewisecollection" component={routewisecollection} />
          <Route path="/CollectionPaymentReport" component={CollectionPaymentReport} />
          <Route path="/ExpenseSummeryReport" component={ExpenseSummeryReport} />
          <Route path="/RouteOrderlistReport" component={RouteOrderlistReport} />
          <Route path="/Ledger" component={Ledger} />
          <Route path="/SalesnewReport" component={SalesnewReport} />
          <Route path="/RouteWiseOutstandingReport" component={RouteWiseOutstandingReport} />
          <Route path="/ForLoadingDespatchReport" component={ForLoadingDespatchReport} />
          <Route path="/MonthlySaleReport" component={MonthlySaleReport} />
          <Route path="/SaleReturnReport" component={SaleReturnReport} />
          <Route path="/ChequeStatus" component={ChequeStatus} />
          <Route path="/Salegstreport" component={Salegstreport} />
          <Route path="/DeletedReceiptList" component={DeletedReceiptList} />
          {/* <Route path="/CounterSaleReport" component={CounterSaleReport}/> */}

          {/*  bank */}
          <Route path="/BankCreate" component={BankCreate} />
          <Route path="/BankIndex" component={BankIndex} />
          <Route path="/BankEdit/:id" component={BankEdit} />


          {/* Delivery */}
          {/* <Route path="/Despatch" component={Despatch}/> */}
          <Route path="/Despatch/:id" component={Despatch} />
          <Route path="/ReceiptIndex" component={ReceiptIndex} />
          <Route path="/ReceiptCreate" component={ReceiptCreate} />
          <Route path="/InvoicePrint/:id/cid" component={InvoicePrint} />
          <Route path="/Delivery" component={Delivery} />
          <Route path="/ReceiptDetails/:id" component={ReceiptDetails} />
          {/*  PriceList */}
          <Route path="/PriceList" component={PriceList} />

          {/* Income */}
          <Route path="/IncomeIndex" component={IncomeIndex} />
          <Route path="/IncomeCreate" component={IncomeCreate} />
          <Route path="/IncomeEdit/:id" component={IncomeEdit} />

          {/* CounterSale */}

          <Route path="/CounterSaleCreate" component={CounterSaleCreate} />
          {/* <Route path="/CounterSaleEdit/:Id" component={CounterSaleEdit} /> */}
          <Route path="/CounterSaleIndex" component={CounterSaleIndex} />
        </Switch>
      </AuthProvider >
    </Router >
  );
};

export default App;

